import { Col, Row } from 'antd';
import * as React from "react";
import { Headline1 } from 'src/components/common/Paragraphs/Paragraphs';
import './SCSS/NotFound.scss';
import notFoundImage from "../../../assets/naoencontrado.svg";

import StandardButton from 'src/components/common/StandardButton/StandardButton';
import { Link } from 'react-router-dom';

export function NotFound() {

    return <div>

        <section style={{ marginTop: 60, padding: 20 }}>
            <div className="content-404">
                <Row>
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <Headline1 style={{ textAlign: "left", fontSize: 39 }}>
                            Página não encontrada...
                        </Headline1>
                        <h2 style={{ textAlign: "left", fontSize: 20, paddingBottom: '10px' }}>
                            Não achamos essa página, mas encontramos um artigo explicando tudo o que você precisa saber sobre precatórios!
                        </h2>

                        <Row gutter={16} className="actions-btn-row">
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <StandardButton href={'https://blog.precatoriosbrasil.com/o-que-e-precatorio/'}>
                                    Quero ler o artigo!
                                </StandardButton>
                            </Col>
                            <Col xs={24} sm={24} md={24} lg={12}>
                                <StandardButton preset="outline">
                                    <Link to="/">
                                        Ir para início
                                    </Link>
                                </StandardButton>
                            </Col>
                        </Row>

                    </Col>
                    <Col xs={24} sm={24} md={6} lg={6}>
                        <img style={{ height: 277, width: "100%", margin: "auto" }} src={notFoundImage} />
                    </Col>
                </Row>
            </div>

        </section>
    </div>
}

export { NotFound as default };



// WEBPACK FOOTER //
// ./src/pages/erros/NotFound/NotFound.tsx